<template>
	<v-sheet>
        <MwList store-module="profileFields" :columns="headers" path="profile-fields">

        </MwList>
    </v-sheet>
</template>

<script type="text/javascript">
import MwList from "@c/ui/MwList";
export default {
	name: "ProfileField",
    data: () => {
        return {
            filtered: false
        }
    },
	computed: {
		headers() {
			return [
				{value: "name", text: "Name", default: true},
			];
		},
	},
	components: {
		MwList
	},
};
</script>

